/**
 * EyesOnOff sticky ATC — IntersectionObserver + Impulse variant sync.
 * Does not modify theme.js. Easy to disable via Theme Editor setting.
 */
(function () {
  var MOBILE_MQ = window.matchMedia('(max-width: 769px)');

  function initStickyAtc(bar) {
    if (!bar || bar.dataset.eooInit === 'true') return;
    bar.dataset.eooInit = 'true';

    var section = bar.closest('[data-section-type="product"]');
    if (!section) return;

    var mainBtn = section.querySelector('[data-add-to-cart]');
    var mainText = section.querySelector('[data-add-to-cart-text]');
    var mainPrice = section.querySelector('[data-product-price]');
    var stickyBtn = bar.querySelector('[data-eoo-sticky-atc-button]');
    var stickyText = bar.querySelector('[data-eoo-sticky-atc-text]');
    var stickyPrice = bar.querySelector('[data-eoo-sticky-price]');
    var stickyOptions = bar.querySelector('[data-eoo-sticky-variant]');
    var mobileOnly = bar.getAttribute('data-mobile-only') === 'true';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!mainBtn || !stickyBtn) return;

    function isMobileContext() {
      return !mobileOnly || MOBILE_MQ.matches;
    }

    function syncFromMain() {
      if (stickyText && mainText) {
        stickyText.textContent = mainText.textContent.trim();
      }
      stickyBtn.disabled = mainBtn.disabled;
      if (stickyPrice && mainPrice) {
        stickyPrice.textContent = mainPrice.textContent.trim();
      }
      if (stickyOptions) {
        stickyOptions.replaceChildren();
        section.querySelectorAll('.variant-wrapper').forEach(function (wrapper) {
          var input = wrapper.querySelector('.variant-input-wrap input[type="radio"]:checked, .variant-input-wrap select');
          if (!input) return;
          var value = (input.value || '').trim();
          if (!value || value === 'Default Title') return;

          var fieldset = input.closest('fieldset');
          var name = fieldset ? (fieldset.getAttribute('name') || '').trim() : '';
          if (!name) {
            var label = wrapper.querySelector('.variant__label');
            var first = label && label.childNodes[0];
            name = first ? first.textContent.trim() : '';
          }

          var row = document.createElement('span');
          row.className = 'eoo-sticky-atc__option';
          var nameEl = document.createElement('span');
          nameEl.className = 'eoo-sticky-atc__option-name';
          nameEl.textContent = name;
          var valueEl = document.createElement('span');
          valueEl.className = 'eoo-sticky-atc__option-value';
          valueEl.textContent = value;
          row.append(nameEl, valueEl);
          stickyOptions.append(row);
        });
      }
    }

    function syncTop() {
      if (!document.body.classList.contains('eoo-header-docked')) {
        if (bar.classList.contains('is-visible') || bar.classList.contains('is-leaving')) return;
        bar.style.top = '';
        return;
      }
      var header = document.getElementById('SiteHeader');
      bar.style.top = (header ? header.offsetHeight : 0) + 'px';
      bar.classList.remove('is-flush-top');
    }

    var wantsVisible = false;

    function finishLeave(event) {
      if (event && (event.target !== bar || event.propertyName !== 'opacity')) return;
      bar.removeEventListener('transitionend', finishLeave);
      if (bar.classList.contains('is-visible')) return;
      bar.classList.remove('is-leaving');
      if (!document.body.classList.contains('eoo-header-docked')) bar.style.top = '';
      document.body.classList.remove('eoo-sticky-atc-active');
    }

    function hideInPlace() {
      bar.setAttribute('aria-hidden', 'true');
      if (reduceMotion.matches || (!bar.classList.contains('is-visible') && !bar.classList.contains('is-leaving'))) {
        bar.classList.remove('is-visible', 'is-leaving');
        if (!document.body.classList.contains('eoo-header-docked')) bar.style.top = '';
        document.body.classList.remove('eoo-sticky-atc-active');
        return;
      }
      bar.classList.add('is-leaving');
      bar.classList.remove('is-visible');
      bar.removeEventListener('transitionend', finishLeave);
      bar.addEventListener('transitionend', finishLeave);
      window.setTimeout(function () {
        if (!bar.classList.contains('is-visible')) finishLeave();
      }, 320);
    }

    function setVisible(visible) {
      wantsVisible = visible;
      var show = visible && isMobileContext() && document.body.classList.contains('eoo-header-docked');
      if (!isMobileContext()) {
        bar.classList.remove('is-visible', 'is-leaving');
        bar.style.top = '';
        bar.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('eoo-sticky-atc-active');
        return;
      }
      if (show) {
        bar.removeEventListener('transitionend', finishLeave);
        bar.classList.remove('is-leaving');
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
        document.body.classList.add('eoo-sticky-atc-active');
        return;
      }
      hideInPlace();
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          setVisible(!entry.isIntersecting);
        });
      },
      { root: null, threshold: 0, rootMargin: '0px' }
    );

    observer.observe(mainBtn);
    bar._eooSyncDock = function () {
      syncTop();
      setVisible(wantsVisible);
    };

    stickyBtn.addEventListener('click', function () {
      if (mainBtn.disabled) return;
      mainBtn.click();
    });

    section.addEventListener('variantChange', syncFromMain);
    section.addEventListener('variantPriceChange', syncFromMain);

    if (typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(syncFromMain);
      mo.observe(mainBtn, { attributes: true, attributeFilter: ['disabled'] });
      if (mainText) {
        mo.observe(mainText, { childList: true, characterData: true, subtree: true });
      }
      if (mainPrice) {
        mo.observe(mainPrice, { childList: true, characterData: true, subtree: true });
      }
    }

    if (typeof MOBILE_MQ.addEventListener === 'function') {
      MOBILE_MQ.addEventListener('change', function () {
        if (!isMobileContext()) {
          setVisible(false);
        } else if (mainBtn.getBoundingClientRect().bottom < 0 || mainBtn.getBoundingClientRect().top > window.innerHeight) {
          setVisible(true);
        }
      });
    }

    syncFromMain();
  }

  var dockQuery = window.matchMedia('(max-width: 768px)');
  var announcementWatch;

  function notifyBars() {
    document.querySelectorAll('[data-eoo-sticky-atc]').forEach(function (bar) {
      if (typeof bar._eooSyncDock === 'function') bar._eooSyncDock();
    });
  }

  function setHeaderDocked(docked) {
    var mobilePdp = document.body.classList.contains('template-product') && dockQuery.matches;
    document.body.classList.toggle('eoo-header-docked', mobilePdp && docked);
    notifyBars();
  }

  function watchAnnouncement() {
    if (!document.body.classList.contains('template-product')) return;
    var announcement = document.querySelector('.announcement-bar');
    if (!announcement) {
      setHeaderDocked(true);
      return;
    }
    if (announcementWatch) return;
    announcementWatch = new IntersectionObserver(function (entries) {
      setHeaderDocked(!entries[0].isIntersecting);
    }, { threshold: 0 });
    announcementWatch.observe(announcement);
  }

  function boot() {
    document.querySelectorAll('[data-eoo-sticky-atc]').forEach(initStickyAtc);
    watchAnnouncement();
  }

  if (typeof dockQuery.addEventListener === 'function') {
    dockQuery.addEventListener('change', function () {
      var announcement = document.querySelector('.announcement-bar');
      if (!announcement) {
        setHeaderDocked(dockQuery.matches);
        return;
      }
      setHeaderDocked(announcement.getBoundingClientRect().bottom <= 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
